import { render } from "./RegisterPage.vue?vue&type=template&id=51fe8603&scoped=true"
import script from "./RegisterPage.vue?vue&type=script&lang=js"
export * from "./RegisterPage.vue?vue&type=script&lang=js"

import "./RegisterPage.vue?vue&type=style&index=0&id=51fe8603&scoped=true&lang=css"

import exportComponent from "/home/acartia-ops/acartia/src/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51fe8603"]])

export default __exports__